import { createContext, useContext, useState } from "react";
import en from './en';
import mr from './mr';

// Create Context
const LanguageContext = createContext();

// Combine all translations
const translations = {
  en,
  mr,
};

// Provider Component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom Hook
export const useLanguage = () => useContext(LanguageContext);